module.exports = __webpack_public_path__ + "static/img/frontpage4.78ccaeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frontpage4.jpg
// module id = w0c2
// module chunks = 0